import { Component, h, Prop, Watch, State } from '@stencil/core';
import { RouterHistory, MatchResults, ActiveRouter } from '@stencil/router';
import URLS from '../../app-root/urls';
import partnersList from '../partners';

const pageInfo = {
  pageURL: URLS.PartnersPartner,
  pageTitle: 'Parteneriate - Blugento',
  pageDescription: "Partener Blugento",
  keywords: "parteneri, parteneriat, servicii, blugento, training, cursuri, educație",
  ogimage: 'assets/icon/var_og-image.png'
};

@Component({
  tag: 'page-partners-partner',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})

export class PagePartnersPartner {
  @Prop() match: MatchResults;
  @Prop() history: RouterHistory;
  @Prop() router: ActiveRouter;

  @State() partner: any;

  @Watch('match')
  componentWillLoad() {
    const matchedEvent = partnersList.filter(e => e.url === this.match.params.partner);
    this.partner = matchedEvent.pop();
    // TODO: handle not found
  }

  componentDidRender() {
    document.title = this.partner.title + ' ' + pageInfo.pageTitle;
    document.querySelector('meta[name="Description"]').setAttribute('content', pageInfo.pageDescription+' '+this.partner.title);
    document.querySelector('meta[property="og:description"]').setAttribute('content', this.partner.title+', '+pageInfo.pageDescription);
  }

  render() {
    const tmp = this.partner.image.split('.');
    const img ='../../assets/'+tmp[0];
    const imgExt = tmp[1];
    const desktopOriginal = img ? img+'.'+imgExt : null;
    const desktopOriginal2x = img ? img+'_2x.'+imgExt : null;
    const desktopWebp = img ? img+'.webp' : null;
    const desktopWebp2x = img ? img+'_2x.webp' : null;

    return (
      <div class='page-partners-partner'>
        <app-meta
          titleStr={pageInfo.pageTitle}
          description={pageInfo.pageDescription}
          keywords={pageInfo.keywords}
          image={pageInfo.ogimage}
          urlKey={pageInfo.pageURL}
        />
        
        <div class='partners-heading'>
          <div class='item-info'>
            <div class='item-info-inner'>
              <h4>Parteneri</h4>
              <h1>{ this.partner.title }</h1>
              <p>{this.partner.description}</p>
            </div>
          </div>
          <div class='item-image'>
            {imgExt === 'svg' ?
              <img
                class='logoimg'
                src={ '../../assets/'+this.partner.image }
                alt={ this.partner.title }
                loading='lazy'
              />
            :
              <picture>
                <source
                  media='(min-width:320px)'
                  srcSet={ `${desktopWebp} 1x, ${desktopWebp2x} 2x` }
                  type='image/webp'
                />

                <img
                  class='logoimg'
                  src={ desktopOriginal }
                  srcSet={ `${desktopOriginal} 1x, ${desktopOriginal2x} 2x` }
                  alt={ this.partner.title }
                  loading='lazy'
                />
              </picture>
            }
          </div>
        </div>

        {this.partner.intro !== undefined ?
          <app-pages-intro>
            {this.partner.intro.map(e => (<p innerHTML={e}></p>))}
          </app-pages-intro>
        : ''}

        <div class='page-container'>
          {this.partner.services !== undefined && this.partner.services.length > 0 ?
            <div class='partners-services-wrapper'>
              <h2>{this.partner.servicesLabel !== undefined ? this.partner.servicesLabel : "Servicii"}</h2>
              <div class='partners-services-items'>
                {this.partner.services.map(e => (
                  <div class='partners-services-item'>
                    <div class='partners-services-item-inner'>
                      <h3>{e.name}</h3>
                      <p>{e.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
        : ''}
        </div>

        <app-contact-us/>
      </div>
    );
  }
}
